import React from "react";
import { Link } from "react-router-dom";
import { BelumMengisiButton } from "./BelumMengisiButton";

function Row({ p }) {
  const pct = p.total ? Math.round((p.sudah / p.total) * 100) : 0;
  return (
    <tr className="border-t border-slate-100 hover:bg-slate-50 transition-colors" data-testid={`progress-row-${p.id}`}>
      <td className="py-3 pr-4">
        <Link to={`/admin/periode/${p.id}`} className="font-semibold text-navy-900 hover:text-brass-600">
          {p.nama_periode || `${p.jenis === "mingguan" ? "Minggu" : "Bulan"} ke-${p.nomor}`}
        </Link>
        <div className="text-xs text-slate-500">{p.kelompok_nama || "Tanpa kelompok"} · {p.bulan} {p.tahun}</div>
      </td>
      <td className="py-3 pr-4">
        <span className={`px-2 py-0.5 text-xs font-semibold rounded-sm border ${p.status === "open" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-slate-100 text-slate-600 border-slate-200"}`}>
          {p.status === "open" ? "Aktif" : "Ditutup"}
        </span>
      </td>
      <td className="py-3 pr-4 font-mono font-bold text-emerald-700" data-testid={`progress-sudah-${p.id}`}>{p.sudah}</td>
      <td className="py-3 pr-4 font-mono font-bold text-amber-600" data-testid={`progress-belum-${p.id}`}>{p.belum}</td>
      <td className="py-3 pr-4"><BelumMengisiButton periode={p} /></td>
      <td className="py-3 w-48">
        <div className="h-2 bg-slate-100 rounded-sm overflow-hidden">
          <div className="h-full bg-brass-500 transition-[width] duration-500" style={{ width: `${pct}%` }} />
        </div>
        <div className="text-[10px] text-slate-500 mt-1 font-mono">{p.sudah}/{p.total} · {pct}%</div>
      </td>
    </tr>
  );
}

export function PeriodeProgress({ items }) {
  return (
    <div className="bg-white border border-slate-200 rounded-sm p-6 mb-8" data-testid="dashboard-periode-progress">
      <h2 className="font-heading font-bold text-lg text-navy-900 mb-1">Progres Pengisian Sosiometri</h2>
      <p className="text-sm text-slate-500 mb-4">Jumlah Serdik yang sudah dan belum mengisi per jadwal.</p>
      {!items ? <div className="text-slate-500 text-sm">Memuat...</div> : items.length === 0 ? (
        <div className="text-slate-500 text-sm" data-testid="progress-empty">Belum ada jadwal pengisian.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead>
              <tr className="text-xs uppercase tracking-wide text-slate-500">
                <th className="pb-2 pr-4 font-semibold">Jadwal</th>
                <th className="pb-2 pr-4 font-semibold">Status</th>
                <th className="pb-2 pr-4 font-semibold">Sudah</th>
                <th className="pb-2 pr-4 font-semibold">Belum</th>
                <th className="pb-2 pr-4 font-semibold">Nama</th>
                <th className="pb-2 font-semibold">Progres</th>
              </tr>
            </thead>
            <tbody>{items.map((p) => <Row key={p.id} p={p} />)}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
